import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
    },
  },
  innerContainer: {
    marginLeft: "45px",
    display: "flex",
    flexDirection: "column",
    width: "100px",
    textAlign: "left",
    gap: "4px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  labelOne: {
    color: theme.palette.customColor.PLACEHOLDER,
  },
  labelCompleted: {
    backgroundColor: "#DEF5D9",
    color: theme.palette.customColor.SUCCESS,
    padding: "4px 8px",
    borderRadius: "5px",
    width: "max-content",
  },
  labelPending: {
    backgroundColor: theme.palette.customColor.INPUT,
    color: theme.palette.customColor.PLACEHOLDER,
    padding: "4px 8px",
    borderRadius: "5px",
  },
  labelProgress: {
    backgroundColor: theme?.palette?.customColor?.ACCENTS?.ACCENT_5,
    color: theme?.palette?.customColor?.TERTIARY,
    padding: "4px 8px",
    borderRadius: "5px",
  },
}));
